__webpack_require__.p = "https://docscout-yika.dba.legal.amazon.dev/";